import { Fragment, useState } from "react";

import { Button } from "@mui/material";
import CustomModal from "../../Common/Modal/CustomModal";
import DeleteIcon from "@mui/icons-material/Delete";
import EditNoteIcon from "@mui/icons-material/EditNote";
import EditIcon from "@mui/icons-material/Edit";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { Link } from "react-router-dom";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import QuestionAnswerOutlinedIcon from "@mui/icons-material/QuestionAnswerOutlined";
import React from "react";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import AddIcon from "@mui/icons-material/Add";
import StopCircleIcon from "@mui/icons-material/StopCircle";
import Tooltip from "@mui/material/Tooltip";
import { useModalToggle } from "../../../hooks/useModalToggle";
import { useTranslation } from "react-i18next";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SupervisorAccountOutlinedIcon from "@mui/icons-material/SupervisorAccountOutlined";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWorkOutlined";

const ButtonColumn = (props) => {
  const {
    handleButtonChangeStoreClick,
    handleButtonChangeTypeClick,
    handleButtonChangeSectorClick,
    handleButtonAddPointsClick,
    activeItemTitle,
    deactiveItemTitle,
    approveItemTitle,
    rejectItemTitle,
    submitActionModal,
    editLink,
    value,
    editLinkDetail,
    textToltipDetail,
    deleteItemId,
    status,
    lesson,
    question,
    deleteItemTitle,
    addPoints,
    editSector,
    editStore,
    editType,
    textToltip,
    buttonStatistic = false,
  } = props || {};

  const [showModal, toggleModal] = useModalToggle(false);
  const [titleModal, setTitleModal] = useState("");
  const [bodyTextModal, setBodyTextModal] = useState("");
  const [typeAction, setTypeAction] = useState("");
  const { t } = useTranslation();

  const handleButtonRemoveClick = () => {
    setTitleModal(t("confirmation.delete.title"));
    setBodyTextModal(
      `${t("confirmation.delete.message")} <b>${deleteItemTitle}</b>?`
    );
    setTypeAction("delete");
    toggleModal();
  };

  const handleButtonActiveClick = () => {
    setTitleModal(t("confirmation.activate.title"));
    setBodyTextModal(
      `${t("confirmation.activate.message")} <b>${activeItemTitle}</b>?`
    );
    setTypeAction("active");
    toggleModal();
  };

  const handleButtonDeactiveClick = () => {
    setTitleModal(t("confirmation.deactivate.title"));
    setBodyTextModal(
      `${t("confirmation.deactivate.message")} <b>${deactiveItemTitle}</b>?`
    );
    setTypeAction("deactive");
    toggleModal();
  };

  const handleButtonApproveClick = () => {
    setTitleModal(t("confirmation.approve.title"));
    setBodyTextModal(
      `${t("confirmation.approve.message")} <b>${approveItemTitle}</b>?`
    );
    setTypeAction("approve");
    toggleModal();
  };

  const handleButtonRejectClick = () => {
    setTitleModal(t("confirmation.reject.title"));
    setBodyTextModal(
      `${t("confirmation.reject.message")} <b>${rejectItemTitle}</b}?`
    );
    setTypeAction("reject");
    toggleModal();
  };

  const modalCloseHandler = () => {
    toggleModal(false);
  };

  return (
    <Fragment>
      <div className="d-flex align-items-center justify-content-between gap-1">
        {activeItemTitle && status == "INACTIVE" && (
          <Tooltip
            title={t("tooltip.activate")}
            disableInteractive
            placement="top"
            arrow={true}
            onClick={handleButtonActiveClick}
            className="special-aggrid-action-button-spec"
          >
            <PlayArrowIcon className="custom-btn-aggrid-customization" />
          </Tooltip>
        )}
        {deactiveItemTitle && status == "ACTIVE" && (
          <Tooltip
            title={t("tooltip.deactivate")}
            disableInteractive
            placement="top"
            arrow={true}
            onClick={handleButtonDeactiveClick}
            className="special-aggrid-action-button-spec"
          >
            <StopCircleIcon
              disabled={status == "INACTIVE"}
              className="custom-btn-aggrid-customization"
            />
          </Tooltip>
        )}
        {addPoints && (
          <Tooltip
            title={t("tooltip.addPoints")}
            disableInteractive
            placement="top"
            arrow={true}
            disabled={status == "ACTIVE"}
            onClick={() => handleButtonAddPointsClick(addPoints)}
            className="special-aggrid-action-button-spec"
          >
            <AddIcon className="custom-btn-aggrid-customization" />
          </Tooltip>
        )}
        {editSector && (
          <Tooltip
            title={t("tooltip.editSector")}
            disableInteractive
            placement="top"
            arrow={true}
            disabled={status == "ACTIVE"}
            onClick={() => handleButtonChangeSectorClick(editSector)}
            className="special-aggrid-action-button-spec"
          >
            <ManageAccountsIcon className="custom-btn-aggrid-customization" />
          </Tooltip>
        )}
        {editStore && (
          <Tooltip
            title={t("tooltip.editStore")}
            disableInteractive
            placement="top"
            arrow={true}
            disabled={status == "ACTIVE"}
            onClick={() => handleButtonChangeStoreClick(editStore)}
            className="special-aggrid-action-button-spec"
          >
            <HomeWorkOutlinedIcon className="custom-btn-aggrid-customization" />
          </Tooltip>
        )}
        {editType && (
          <Tooltip
            title={t("tooltip.editType")}
            disableInteractive
            placement="top"
            arrow={true}
            disabled={status == "ACTIVE"}
            onClick={() => handleButtonChangeTypeClick(editType)}
            className="special-aggrid-action-button-spec"
          >
            <SupervisorAccountOutlinedIcon className="custom-btn-aggrid-customization" />
          </Tooltip>
        )}
        {approveItemTitle && (
          <Button
            variant="contained"
            color="info"
            size="small"
            className="mr-2 special-aggrid-action-button"
            startIcon={<PlayArrowIcon />}
            disabled={status == "APPROVED" || status == "REJECTED"}
            onClick={handleButtonApproveClick}
          >
            {t("button.approve")}
          </Button>
        )}
        {rejectItemTitle && (
          <Button
            variant="contained"
            color="error"
            size="small"
            className="mr-2 special-aggrid-action-button"
            disabled={status == "APPROVED" || status == "REJECTED"}
            startIcon={<StopCircleIcon />}
            onClick={handleButtonRejectClick}
          >
            {t("button.reject")}
          </Button>
        )}
        {editLinkDetail && (
          <Link to={editLinkDetail}>
            <Tooltip
              title={textToltipDetail}
              disableInteractive
              placement="top"
              arrow={true}
              disabled
              className="special-aggrid-action-button-spec"
            >
              <ListAltOutlinedIcon className="custom-btn-aggrid-customization" />
            </Tooltip>
          </Link>
        )}
        {editLink && (
          <Link to={editLink}>
            <Tooltip
              title={textToltip || t("button.change")}
              disableInteractive
              placement="top"
              arrow={true}
              disabled
              className="special-aggrid-action-button-spec"
            >
              <EditIcon className="custom-btn-aggrid-customization" />
            </Tooltip>
          </Link>
        )}
        {lesson && (
          <Tooltip title={t("tooltip.lessons")} placement="top" arrow={true}>
            <Link to="/lesson-list">
              <SchoolOutlinedIcon className="custom-btn-aggrid-customization item-aggrid-action-icon" />
            </Link>
          </Tooltip>
        )}
        {question && (
          <Tooltip
            title={t("tooltip.questionsAndAnswers")}
            placement="top"
            arrow={true}
          >
            <Link to="/question-list">
              <QuestionAnswerOutlinedIcon className="custom-btn-aggrid-customization item-aggrid-action-icon" />
            </Link>
          </Tooltip>
        )}
        {deleteItemTitle && (
          <Tooltip
            title={t("tooltip.delete")}
            disableInteractive
            placement="top"
            arrow={true}
            className="special-aggrid-action-button-spec"
          >
            <DeleteIcon
              className="edit-button-aggrid-delete-button custom-btn-aggrid-customization"
              onClick={handleButtonRemoveClick}
            />
          </Tooltip>
        )}
      </div>
      {showModal && (
        <CustomModal
          show={showModal}
          hideModal={modalCloseHandler}
          modalTitle={titleModal}
          actionSubmitModal={() => {
            submitActionModal(deleteItemId, typeAction);
            toggleModal(false);
          }}
        >
          <span dangerouslySetInnerHTML={{ __html: bodyTextModal }} />
        </CustomModal>
      )}
    </Fragment>
  );
};

export default ButtonColumn;
